<template>
  <div style="text-align:left;">
    <TopNav />
    <div class="column-left">
      <SideNav />
    </div>

    <div class="column-right">
      <div v-if="admin_datos.superadmin" class="main-container">
        <div class="articulo-principal">
          <div class="header">
            <div>
              <h2>{{ pageTitle }}</h2>
              <p class="subtitle">
                {{ pageSubtitle }}
              </p>
            </div>
            <div class="filters">
              <button
                class="btn btn-toggle"
                :class="{ active: activeDocumentType === 'comisiones' }"
                @click="activeDocumentType = 'comisiones'"
              >
                Comisiones
              </button>
              <button
                class="btn btn-toggle"
                :class="{ active: activeDocumentType === 'puntos' }"
                @click="activeDocumentType = 'puntos'"
              >
                Puntos Jobbing
              </button>
              <button
                class="btn btn-toggle"
                :class="{ active: activeTab === 'pendientes' }"
                @click="activeTab = 'pendientes'"
              >
                Pendientes
              </button>
              <button
                class="btn btn-toggle"
                :class="{ active: activeTab === 'documentos' }"
                @click="activeTab = 'documentos'"
              >
                Documentos subidos
              </button>
              <label for="month">Mes</label>
              <input id="month" type="month" v-model="selectedMonth" />
              <label class="checkbox-inline" for="include-previous-month">
                <input
                  id="include-previous-month"
                  type="checkbox"
                  v-model="includePreviousMonth"
                />
                {{ includePreviousMonthLabel }}
              </label>
              <button
                class="btn btn-std"
                @click="refreshActiveTab"
                :disabled="loading"
              >
                Buscar
              </button>
            </div>
          </div>

          <div v-if="loading" class="status">Cargando...</div>
          <div v-else-if="activeTab === 'pendientes'">
            <div v-if="pendientes.length === 0" class="status">
              No hay documentos pendientes para este mes.
            </div>
            <div v-else class="table-shell">
              <table class="main-table">
              <thead>
                <tr>
                  <th></th>
                  <th>Profesional</th>
                  <th>Empresa</th>
                  <th>Email</th>
                  <th>{{ pendingCountLabel }}</th>
                  <th v-if="activeDocumentType === 'puntos'">Puntos</th>
                  <th>{{ pendingAmountLabel }}</th>
                  <th>Documento</th>
                  <th>Archivo</th>
                  <th>Acción</th>
                </tr>
              </thead>
              <tbody>
                <template v-for="item in pendientes">
                  <tr :key="`row-${item.profesional.id}`">
                    <td>
                      <button class="expand-btn" @click="toggleExpanded(item.profesional.id)">
                        <b-icon :icon="expandedRows[item.profesional.id] ? 'chevron-down' : 'chevron-right'" />
                      </button>
                    </td>
                    <td>
                      <div class="professional-cell">
                        <img
                          v-if="item.profesional.foto"
                          :src="item.profesional.foto"
                          :alt="item.profesional.nombre"
                          class="person-img"
                        >
                        <div v-else class="person-placeholder">
                          {{ item.profesional.nombre ? item.profesional.nombre.charAt(0) : '?' }}
                        </div>
                        <div>
                          <div class="prof-name">{{ item.profesional.nombre }} {{ item.profesional.apellido }}</div>
                          <div class="prof-meta">ID #{{ item.profesional.id }}</div>
                        </div>
                      </div>
                    </td>
                    <td>
                      <span v-if="item.profesional.empresa">
                        {{ item.profesional.empresa.nombre }}
                      </span>
                      <span v-else>Sin empresa</span>
                    </td>
                    <td>{{ item.profesional.email || 'Sin email' }}</td>
                    <td>{{ getPendingItemCount(item) }}</td>
                    <td v-if="activeDocumentType === 'puntos'">
                      {{ formatCurrency(getSelectedPoints(item)) }} pts
                    </td>
                    <td>${{ formatCurrency(getSelectedTotal(item)) }}</td>
                    <td>
                      <div class="doc-fields">
                        <select v-model="uploadData[item.profesional.id].tipo_documento">
                          <option value="boleta">Boleta</option>
                          <option value="factura">Factura</option>
                        </select>
                        <input
                          type="date"
                          v-model="uploadData[item.profesional.id].fecha_documento"
                        />
                      </div>
                    </td>
                    <td>
                      <input
                        type="file"
                        @change="handleFileChange(item.profesional.id, $event)"
                      />
                      <div v-if="uploadData[item.profesional.id].error" class="error">
                        {{ uploadData[item.profesional.id].error }}
                      </div>
                    </td>
                    <td>
                      <button
                        class="btn btn-std"
                        @click="uploadDocumento(item.profesional.id)"
                        :disabled="uploadData[item.profesional.id].uploading"
                      >
                        {{
                          uploadData[item.profesional.id].uploading
                            ? 'Subiendo...'
                            : 'Subir'
                        }}
                      </button>
                    </td>
                  </tr>
                  <tr
                    v-if="expandedRows[item.profesional.id]"
                    :key="`details-${item.profesional.id}`"
                    class="details-row"
                  >
                    <td :colspan="pendingColspan">
                      <div class="details-panel">
                        <div v-if="activeDocumentType === 'comisiones'" class="payment-data">
                          <div class="payment-title">Datos de pago del profesional</div>
                          <div class="payment-grid">
                            <div>
                              <strong>Nombre:</strong>
                              <span>
                                {{ getNombreTransferencia(item.profesional) }}
                              </span>
                              <button
                                class="copy-btn"
                                type="button"
                                @click="copyText(getNombreTransferencia(item.profesional))"
                                title="Copiar nombre"
                                aria-label="Copiar nombre"
                              >
                                📋
                              </button>
                            </div>
                            <div>
                              <strong>RUT:</strong>
                              <span>{{ item.profesional.rut_transferencia || '-' }}</span>
                              <button
                                class="copy-btn"
                                type="button"
                                @click="copyText(item.profesional.rut_transferencia)"
                                title="Copiar RUT"
                                aria-label="Copiar RUT"
                              >
                                📋
                              </button>
                            </div>
                            <div>
                              <strong>Banco:</strong>
                              <span>{{ item.profesional.banco_nombre || '-' }}</span>
                            </div>
                            <div>
                              <strong>Tipo de cuenta:</strong>
                              <span>{{ item.profesional.tipo_cuenta_nombre || '-' }}</span>
                            </div>
                            <div>
                              <strong>Número de cuenta:</strong>
                              <span>{{ item.profesional.cuenta_bancaria || '-' }}</span>
                            </div>
                          </div>
                        </div>
                        <table v-if="activeDocumentType === 'comisiones'" class="details-table">
                          <thead>
                            <tr>
                              <th></th>
                              <th>ID Pago</th>
                              <th>Orden</th>
                              <th>Fecha pago</th>
                              <th>Monto</th>
                              <th>Comision original</th>
                              <th>Ajuste reembolso</th>
                              <th>Comision a documentar</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="pago in item.pagos" :key="pago.id">
                              <td>
                                <input
                                  type="checkbox"
                                  :value="pago.id"
                                  v-model="uploadData[item.profesional.id].selectedItems"
                                />
                              </td>
                              <td>{{ pago.id }}</td>
                              <td>{{ pago.orden_id }}</td>
                              <td>
                                {{ formatDate(pago.fecha_pagado) }}
                                <span v-if="pago.es_mes_anterior" class="badge-previous">Mes anterior</span>
                              </td>
                              <td>${{ formatCurrency(pago.monto) }}</td>
                              <td>${{ formatCurrency(pago.comision_calculada) }}</td>
                              <td>
                                <span v-if="getPagoRefundCommissionReversal(pago) > 0" class="refund-adjustment">
                                  -${{ formatCurrency(getPagoRefundCommissionReversal(pago)) }}
                                </span>
                                <span v-else>-</span>
                              </td>
                              <td>
                                <strong>${{ formatCurrency(getPagoComisionDocumentable(pago)) }}</strong>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <table v-else class="details-table">
                          <thead>
                            <tr>
                              <th></th>
                              <th>ID Compra</th>
                              <th>ID Pago</th>
                              <th>Fecha pago</th>
                              <th>Puntos</th>
                              <th>Monto</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="compra in item.compras" :key="compra.id">
                              <td>
                                <input
                                  type="checkbox"
                                  :value="compra.id"
                                  v-model="uploadData[item.profesional.id].selectedItems"
                                />
                              </td>
                              <td>{{ compra.id }}</td>
                              <td>{{ compra.pago_id || '-' }}</td>
                              <td>
                                {{ formatDate(compra.fecha_pagado) }}
                                <span v-if="compra.es_mes_anterior" class="badge-previous">Mes anterior</span>
                              </td>
                              <td>{{ formatCurrency(compra.puntos) }} pts</td>
                              <td><strong>${{ formatCurrency(compra.monto) }}</strong></td>
                            </tr>
                          </tbody>
                        </table>
                        <div class="details-summary" v-if="!uploadData[item.profesional.id].selectedItems.length">
                          Debes seleccionar al menos un item para subir el documento.
                        </div>
                      </div>
                    </td>
                  </tr>
                </template>
                <tr class="total-row">
                  <td colspan="4"><strong>Total general</strong></td>
                  <td><strong>{{ totalItemsPendientes }}</strong></td>
                  <td v-if="activeDocumentType === 'puntos'">
                    <strong>{{ formatCurrency(totalPuntosPendientesSeleccionados) }} pts</strong>
                  </td>
                  <td><strong>${{ formatCurrency(totalComisionPendienteSeleccionada) }}</strong></td>
                  <td colspan="3"></td>
                </tr>
              </tbody>
                          </table>
            </div>
          </div>
          <div v-else>
            <div v-if="documentos.length === 0" class="status">
              No hay documentos subidos para este mes.
            </div>
            <div v-else class="table-shell">
              <table class="main-table">
              <thead>
                <tr>
                  <th></th>
                  <th>Profesional</th>
                  <th>Documento</th>
                  <th>Fecha</th>
                  <th v-if="activeDocumentType === 'puntos'">Puntos</th>
                  <th>Monto total</th>
                  <th>Archivo</th>
                </tr>
              </thead>
              <tbody>
                <template v-for="item in documentos">
                  <tr :key="`doc-${item.documento.id}`">
                    <td>
                      <button class="expand-btn" @click="toggleDocumentoExpanded(item.documento.id)">
                        <b-icon :icon="documentosExpanded[item.documento.id] ? 'chevron-down' : 'chevron-right'" />
                      </button>
                    </td>
                    <td>
                      <div class="professional-cell">
                        <img
                          v-if="item.profesional.foto"
                          :src="item.profesional.foto"
                          :alt="item.profesional.nombre"
                          class="person-img"
                        >
                        <div v-else class="person-placeholder">
                          {{ item.profesional.nombre ? item.profesional.nombre.charAt(0) : '?' }}
                        </div>
                        <div>
                          <div class="prof-name">{{ item.profesional.nombre }} {{ item.profesional.apellido }}</div>
                          <div class="prof-meta">ID #{{ item.profesional.id }}</div>
                        </div>
                      </div>
                    </td>
                    <td>{{ item.documento.tipo_documento }}</td>
                    <td>{{ formatDate(item.documento.fecha_documento) }}</td>
                    <td v-if="activeDocumentType === 'puntos'">
                      {{ formatCurrency(item.documento.puntos_total) }} pts
                    </td>
                    <td>${{ formatCurrency(item.documento.monto_total) }}</td>
                    <td>
                      <a
                        v-if="item.documento.url_descarga"
                        :href="item.documento.url_descarga"
                        target="_blank"
                        rel="noreferrer"
                      >
                        Descargar
                      </a>
                    </td>
                  </tr>
                  <tr
                    v-if="documentosExpanded[item.documento.id]"
                    :key="`doc-details-${item.documento.id}`"
                    class="details-row"
                  >
                    <td :colspan="documentColspan">
                      <div class="details-panel">
                        <table v-if="activeDocumentType === 'comisiones'" class="details-table">
                          <thead>
                            <tr>
                              <th>ID Pago</th>
                              <th>Orden</th>
                              <th>Fecha pago</th>
                              <th>Monto</th>
                              <th>Comision original</th>
                              <th>Ajuste reembolso</th>
                              <th>Comision documentada</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="pago in item.pagos" :key="pago.id">
                              <td>{{ pago.id }}</td>
                              <td>{{ pago.orden_id }}</td>
                              <td>{{ formatDate(pago.fecha_pagado) }}</td>
                              <td>${{ formatCurrency(pago.monto) }}</td>
                              <td>${{ formatCurrency(pago.comision_calculada) }}</td>
                              <td>
                                <span v-if="getPagoRefundCommissionReversal(pago) > 0" class="refund-adjustment">
                                  -${{ formatCurrency(getPagoRefundCommissionReversal(pago)) }}
                                </span>
                                <span v-else>-</span>
                              </td>
                              <td>
                                <strong>${{ formatCurrency(getPagoComisionDocumentable(pago)) }}</strong>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <table v-else class="details-table">
                          <thead>
                            <tr>
                              <th>ID Compra</th>
                              <th>ID Pago</th>
                              <th>Fecha pago</th>
                              <th>Puntos</th>
                              <th>Monto</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="compra in item.compras" :key="compra.id">
                              <td>{{ compra.id }}</td>
                              <td>{{ compra.pago_id || '-' }}</td>
                              <td>{{ formatDate(compra.fecha_pagado) }}</td>
                              <td>{{ formatCurrency(compra.puntos) }} pts</td>
                              <td><strong>${{ formatCurrency(compra.monto) }}</strong></td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </td>
                  </tr>
                </template>
                <tr class="total-row">
                  <td colspan="4"><strong>Total general</strong></td>
                  <td v-if="activeDocumentType === 'puntos'">
                    <strong>{{ formatCurrency(totalPuntosDocumentos) }} pts</strong>
                  </td>
                  <td><strong>${{ formatCurrency(totalMontoDocumentos) }}</strong></td>
                  <td></td>
                </tr>
              </tbody>
                          </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import SideNav from '@/components/SideNav.vue';
import TopNav from '@/components/TopNav.vue';

export default {
  name: 'DocumentosTributariosComisiones',
  components: {
    SideNav,
    TopNav,
  },
  data() {
    return {
      loading: false,
      pendientes: [],
      documentos: [],
      selectedMonth: '',
      uploadData: {},
      expandedRows: {},
      documentosExpanded: {},
      activeDocumentType: 'comisiones',
      activeTab: 'pendientes',
      includePreviousMonth: true,
    };
  },
  created() {
    this.selectedMonth = this.getCurrentMonth();
    this.refreshActiveTab();
  },
  computed: {
    ...mapGetters(['admin_datos']),
    pageTitle() {
      return this.activeDocumentType === 'puntos'
        ? 'Documentos tributarios de Puntos Jobbing'
        : 'Documentos tributarios de comisiones';
    },
    pageSubtitle() {
      return this.activeDocumentType === 'puntos'
        ? 'Selecciona el mes para ver compras de puntos con documentos pendientes.'
        : 'Selecciona el mes para ver profesionales con documentos pendientes.';
    },
    includePreviousMonthLabel() {
      return this.activeDocumentType === 'puntos'
        ? 'Incluir compras pendientes del mes anterior'
        : 'Incluir pagos pendientes del mes anterior';
    },
    pendingCountLabel() {
      return this.activeDocumentType === 'puntos' ? 'Compras' : 'Pagos';
    },
    pendingAmountLabel() {
      return this.activeDocumentType === 'puntos' ? 'Monto a documentar' : 'Comision a documentar';
    },
    pendingColspan() {
      return this.activeDocumentType === 'puntos' ? 10 : 9;
    },
    documentColspan() {
      return this.activeDocumentType === 'puntos' ? 7 : 6;
    },
    documentosEndpointBase() {
      return this.activeDocumentType === 'puntos'
        ? `${window.hostname}/api/superadmin/documentos_tributarios_jobbing_points`
        : `${window.hostname}/api/superadmin/documentos_tributarios_comision`;
    },
    totalItemsPendientes() {
      return this.pendientes.reduce((sum, item) => sum + this.getPendingItemCount(item), 0);
    },
    totalComisionPendienteSeleccionada() {
      return this.pendientes.reduce((sum, item) => sum + this.getSelectedTotal(item), 0);
    },
    totalPuntosPendientesSeleccionados() {
      return this.pendientes.reduce((sum, item) => sum + this.getSelectedPoints(item), 0);
    },
    totalMontoDocumentos() {
      return this.documentos.reduce((sum, item) => sum + Number(item.documento?.monto_total || 0), 0);
    },
    totalPuntosDocumentos() {
      return this.documentos.reduce((sum, item) => sum + Number(item.documento?.puntos_total || 0), 0);
    },
  },
  watch: {
    activeTab() {
      this.refreshActiveTab();
    },
    activeDocumentType() {
      this.refreshActiveTab();
    },
  },
  methods: {
    getNombreTransferencia(profesional) {
      if (!profesional) {
        return '';
      }
      return profesional.nombre_transferencia || profesional.nombre || '';
    },
    copyText(text) {
      if (!text) {
        return;
      }
      if (navigator?.clipboard?.writeText) {
        navigator.clipboard.writeText(text);
        return;
      }
      const textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'absolute';
      textarea.style.left = '-9999px';
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);
    },
    getCurrentMonth() {
      const now = new Date();
      return now.toISOString().slice(0, 7);
    },
    formatCurrency(value) {
      return Intl.NumberFormat('de-DE').format(Number(value || 0));
    },
    refreshActiveTab() {
      if (this.activeTab === 'documentos') {
        this.fetchDocumentos();
        return;
      }
      this.fetchPendientes();
    },
    fetchPendientes() {
      this.loading = true;
      axios
        .get(`${this.documentosEndpointBase}/pendientes`, {
          params: {
            month: this.selectedMonth,
            include_previous_month: this.includePreviousMonth,
          },
        })
        .then((response) => {
          this.pendientes = response.data.pendientes || [];
          this.uploadData = {};
          this.expandedRows = {};
          const defaultDate = `${this.selectedMonth}-01`;
          this.pendientes.forEach((item) => {
            const entries = this.getPendingEntries(item);
            this.$set(this.uploadData, item.profesional.id, {
              tipo_documento: 'boleta',
              fecha_documento: defaultDate,
              file: null,
              uploading: false,
              error: '',
              selectedItems: entries
                .filter((entry) => this.getEntryDocumentableAmount(entry) > 0)
                .map((entry) => entry.id),
            });
            this.$set(this.expandedRows, item.profesional.id, false);
          });
        })
        .catch(() => {
          this.pendientes = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
    fetchDocumentos() {
      this.loading = true;
      axios
        .get(this.documentosEndpointBase, {
          params: {
            month: this.selectedMonth,
          },
        })
        .then((response) => {
          this.documentos = response.data.documentos || [];
          this.documentosExpanded = {};
          this.documentos.forEach((item) => {
            this.$set(this.documentosExpanded, item.documento.id, false);
          });
        })
        .catch(() => {
          this.documentos = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
    formatDate(value) {
      if (!value) {
        return '-';
      }
      const parsed = new Date(value);
      if (Number.isNaN(parsed.getTime())) {
        return value;
      }
      return parsed.toLocaleDateString('es-CL');
    },
    toggleExpanded(profesionalId) {
      this.expandedRows[profesionalId] = !this.expandedRows[profesionalId];
    },
    toggleDocumentoExpanded(documentoId) {
      this.documentosExpanded[documentoId] = !this.documentosExpanded[documentoId];
    },
    getPendingEntries(item) {
      if (!item) {
        return [];
      }
      return this.activeDocumentType === 'puntos'
        ? (item.compras || [])
        : (item.pagos || []);
    },
    getPendingItemCount(item) {
      if (!item) {
        return 0;
      }
      return this.activeDocumentType === 'puntos'
        ? Number(item.total_compras || (item.compras || []).length || 0)
        : Number(item.total_pagos || (item.pagos || []).length || 0);
    },
    getEntryDocumentableAmount(entry) {
      if (this.activeDocumentType === 'puntos') {
        return Number(entry?.monto || 0);
      }
      return this.getPagoComisionDocumentable(entry);
    },
    getEntryPoints(entry) {
      return this.activeDocumentType === 'puntos' ? Number(entry?.puntos || 0) : 0;
    },
    getSelectedIds(item) {
      return this.uploadData[item.profesional.id]?.selectedItems || [];
    },
    getSelectedTotal(item) {
      const selectedIds = this.getSelectedIds(item);
      return this.getPendingEntries(item)
        .filter((entry) => selectedIds.includes(entry.id))
        .reduce((sum, entry) => sum + this.getEntryDocumentableAmount(entry), 0);
    },
    getSelectedPoints(item) {
      const selectedIds = this.getSelectedIds(item);
      return this.getPendingEntries(item)
        .filter((entry) => selectedIds.includes(entry.id))
        .reduce((sum, entry) => sum + this.getEntryPoints(entry), 0);
    },
    getPagoComisionDocumentable(pago) {
      if (!pago) {
        return 0;
      }
      const documentable = Number(pago.comision_documentable);
      if (Number.isFinite(documentable)) {
        return documentable;
      }
      return Number(pago.comision_calculada || 0);
    },
    getPagoRefundCommissionReversal(pago) {
      if (!pago) {
        return 0;
      }
      const reversal = Number(pago.refund_commission_reversal || 0);
      return Number.isFinite(reversal) ? reversal : 0;
    },
    handleFileChange(profesionalId, event) {
      const file = event.target.files[0];
      if (!this.uploadData[profesionalId]) {
        return;
      }
      this.uploadData[profesionalId].file = file;
      this.uploadData[profesionalId].error = '';
    },
    uploadDocumento(profesionalId) {
      const data = this.uploadData[profesionalId];
      if (!data || !data.file) {
        this.uploadData[profesionalId].error = 'Selecciona un archivo.';
        return;
      }
      if (!data.fecha_documento) {
        this.uploadData[profesionalId].error = 'Selecciona una fecha de documento.';
        return;
      }
      if (!data.selectedItems.length) {
        this.uploadData[profesionalId].error = this.activeDocumentType === 'puntos'
          ? 'Selecciona al menos una compra.'
          : 'Selecciona al menos un pago.';
        return;
      }
      data.uploading = true;
      data.error = '';
      const formData = new FormData();
      formData.append('file', data.file);
      const documentPayload = {
        profesional_id: profesionalId,
        tipo_documento: data.tipo_documento,
        fecha_documento: data.fecha_documento,
        include_previous_month: this.includePreviousMonth,
      };
      if (this.activeDocumentType === 'puntos') {
        documentPayload.purchase_ids = data.selectedItems;
      } else {
        documentPayload.pagos_ids = data.selectedItems;
      }
      formData.append(
        'document',
        new Blob([JSON.stringify(documentPayload)], { type: 'application/json' }),
        'document.json'
      );

      axios
        .post(this.documentosEndpointBase, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then(() => {
          this.fetchPendientes();
        })
        .catch((error) => {
          const message =
            error.response?.data?.message || 'Error al subir el documento.';
          data.error = message;
        })
        .finally(() => {
          data.uploading = false;
        });
    },
  },
  mounted() {
    if (!this.admin_datos.superadmin) {
      this.$router.push('/');
    }
  },
};
</script>

<style scoped>
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  flex-wrap: wrap;
}
.subtitle {
  color: #6c757d;
  margin-top: 6px;
}
.filters {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}
.checkbox-inline {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
}
.status {
  margin-top: 16px;
  color: #6c757d;
}
.doc-fields {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.error {
  color: #c62828;
  font-size: 12px;
  margin-top: 6px;
}
.refund-adjustment {
  color: #b45309;
  font-weight: 700;
}
.details-row {
  background-color: #fafafa;
}
.details-panel {
  padding: 12px 0;
}
.payment-data {
  margin-bottom: 12px;
  padding: 12px;
  background: #fff;
  border: 1px solid #eee;
  border-radius: 6px;
}
.payment-title {
  font-weight: 600;
  margin-bottom: 8px;
}
.payment-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 8px 16px;
  font-size: 13px;
}
.copy-btn {
  border: none;
  background: transparent;
  cursor: pointer;
  margin-left: 6px;
  font-size: 13px;
}
.copy-btn:hover {
  opacity: 0.7;
}
.details-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 8px;
}
.details-table th,
.details-table td {
  border: 1px solid #eee;
  padding: 8px;
  font-size: 13px;
}
.badge-previous {
  display: inline-block;
  margin-left: 6px;
  padding: 2px 6px;
  border-radius: 10px;
  background: #fff3cd;
  color: #856404;
  font-size: 11px;
}
.details-summary {
  margin-top: 8px;
  color: #c62828;
  font-size: 12px;
}

.table-shell {
  overflow-x: auto;
  margin-top: 20px;
}
.main-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0 10px;
}
.main-table thead th {
  background: #263543;
  color: #fff;
  padding: 12px;
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: .03em;
  border: none;
}
.main-table tbody tr {
  background: #fff;
  box-shadow: 0 2px 8px rgba(38,53,67,.08);
}
.main-table tbody tr.details-row {
  background: transparent;
  box-shadow: none;
}
.main-table td {
  padding: 12px;
  vertical-align: middle;
  border: none;
}
.professional-cell {
  display: flex;
  gap: 10px;
  align-items: center;
}
.prof-name {
  font-weight: 700;
}
.prof-meta {
  color: #6b7280;
  font-size: 12px;
}
.person-img,
.person-placeholder {
  width: 42px;
  height: 42px;
  border-radius: 50%;
}
.person-img {
  object-fit: cover;
}
.person-placeholder {
  background: #e2e8f0;
  color: #334155;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
}
.expand-btn {
  width: 30px;
  height: 30px;
  border-radius: 999px;
  border: 1px solid #d1d5db;
  background: #fff;
  color: #334155;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.total-row td {
  background: #eef2ff;
  font-weight: 700;
  box-shadow: none;
}
.btn-std {
  background-color: #007bff !important;
}
.btn-toggle {
  background-color: #e9ecef;
  border: 1px solid #ced4da;
}
.btn-toggle.active {
  background-color: #007bff;
  color: #fff;
}
.column-right {
  background-color: rgb(242, 247, 251);
  padding-top: 80px;
  padding-left: 260px;
  width: 100%;
}
.main-container {
  background-color: white;
  margin-top: 10px;
  padding: 20px 20px 10px 20px;
}
@media (max-width: 800px) {
  .column-right {
    padding-left: 0px;
  }
}
</style>
